import React from 'react';
import { DownloadIcon, MapPinIcon, StarIcon, SearchIcon, ArrowRightIcon, FileSpreadsheetIcon } from 'lucide-react';
export function ScraperShowcase() {
  return <section className="py-24 bg-slate-50" data-id="element-2290">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2291">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2292">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-2293">
            <span className="text-blue-600" data-id="element-2294">Google Maps</span> scraper
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-2295">
            Automate your Google Maps data collection. Export to CSV, Excel, or
            JSON in just a few minutes!
          </p>
        </div>

        {/* Before / After Visual */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-2296">
          {/* Top Labels */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-slate-200" data-id="element-2297">
            <div className="px-6 py-3 border-b md:border-b-0 md:border-r border-slate-200" data-id="element-2298">
              <span className="text-xs font-bold text-slate-400 tracking-wider" data-id="element-2299">
                BEFORE
              </span>
            </div>
            <div className="px-6 py-3" data-id="element-2300">
              <span className="text-xs font-bold text-blue-600 tracking-wider" data-id="element-2301">
                AFTER
              </span>
            </div>
          </div>

          {/* Content */}
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-2302">
            {/* LEFT: Google Maps listings */}
            <div className="border-b md:border-b-0 md:border-r border-slate-200 p-5 space-y-3" data-id="element-2303">
              {/* Search bar */}
              <div className="bg-slate-50 rounded-lg flex items-center px-3 py-2.5 border border-slate-100" data-id="element-2304">
                <SearchIcon className="w-4 h-4 text-slate-400 mr-2.5 shrink-0" data-id="element-2305" />
                <span className="text-slate-500 text-xs" data-id="element-2306">
                  restaurants near New York, NY
                </span>
              </div>

              {/* Listings */}
              {[{
              name: 'Buena Vista Restaurant',
              rating: '4.7',
              reviews: '1,389',
              type: 'Restaurant · $$'
            }, {
              name: 'Court Square Diner',
              rating: '4.4',
              reviews: '4,043',
              type: 'Diner · $'
            }, {
              name: 'Shukette',
              rating: '4.8',
              reviews: '3,325',
              type: 'Middle Eastern · $$'
            }, {
              name: 'Sea Salt NYC',
              rating: '4.7',
              reviews: '1,077',
              type: 'Seafood · $$'
            }].map((place, i) => <div key={i} className="flex items-start gap-3 py-2.5 border-b border-slate-100 last:border-0" data-id="element-2307">
                  <div className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center shrink-0 mt-0.5" data-id="element-2308">
                    <MapPinIcon className="w-4 h-4 text-slate-400" data-id="element-2309" />
                  </div>
                  <div className="min-w-0" data-id="element-2310">
                    <div className="text-sm font-semibold text-slate-900 truncate" data-id="element-2311">
                      {place.name}
                    </div>
                    <div className="flex items-center gap-1.5 mt-0.5" data-id="element-2312">
                      <span className="text-xs font-medium text-slate-700" data-id="element-2313">
                        {place.rating}
                      </span>
                      <div className="flex" data-id="element-2314">
                        {[...Array(5)].map((_, s) => <StarIcon key={s} className="w-3 h-3 text-yellow-400 fill-yellow-400" data-id="element-2315" />)}
                      </div>
                      <span className="text-xs text-slate-400" data-id="element-2316">
                        ({place.reviews})
                      </span>
                      <span className="text-xs text-slate-400" data-id="element-2317">
                        · {place.type}
                      </span>
                    </div>
                  </div>
                </div>)}
            </div>

            {/* RIGHT: Spreadsheet */}
            <div className="flex flex-col" data-id="element-2318">
              {/* Column headers */}
              <div className="grid grid-cols-3 text-xs font-semibold text-slate-500 border-b border-slate-200 bg-slate-50" data-id="element-2319">
                <div className="px-4 py-2.5 border-r border-slate-200" data-id="element-2320">
                  Name
                </div>
                <div className="px-4 py-2.5 border-r border-slate-200" data-id="element-2321">
                  Phone
                </div>
                <div className="px-4 py-2.5" data-id="element-2322">Website</div>
              </div>

              {/* Data rows */}
              {[['Buena Vista', '(212) 555-0198', 'buenavista.com'], ['Court Square', '(718) 555-0123', 'courtsquare.com'], ['Shukette', '(212) 555-0145', 'shukettenyc.com'], ['Sea Salt NYC', '(212) 555-0167', 'seasaltnyc.com'], ["Joe's Pizza", '(212) 555-0189', 'joespizzanyc.com'], ["Katz's Deli", '(212) 555-0112', 'katzdeli.com'], ['Levain Bakery', '(917) 555-0134', 'levainbakery.com'], ['Los Tacos No.1', '(212) 555-0156', 'lostacos1.com']].map((row, i) => <div key={i} className="grid grid-cols-3 text-xs border-b border-slate-100 last:border-0" data-id="element-2323">
                  <div className="px-4 py-2.5 border-r border-slate-100 font-medium text-slate-900 truncate" data-id="element-2324">
                    {row[0]}
                  </div>
                  <div className="px-4 py-2.5 border-r border-slate-100 text-slate-600 truncate" data-id="element-2325">
                    {row[1]}
                  </div>
                  <div className="px-4 py-2.5 text-blue-600 truncate" data-id="element-2326">
                    {row[2]}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* CTA below */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10" data-id="element-2327">
          <div className="flex items-center gap-3" data-id="element-2328">
            <FileSpreadsheetIcon className="w-5 h-5 text-slate-400" data-id="element-2329" />
            <span className="text-sm text-slate-500" data-id="element-2330">
              Sample list_restaurants.csv
            </span>
          </div>
          <a href="#" className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white font-semibold rounded-full hover:bg-blue-700 transition-colors text-sm" data-id="element-2331">
            <DownloadIcon className="w-4 h-4" data-id="element-2332" />
            View sample list
          </a>
        </div>
      </div>
    </section>;
}